<ng-container *ngIf="props.thumbnailURL$ | async as thumbnailURL; else loadingThumbnail">
  <image-cropper
    *ngIf="(showCropper$ | async) === true; else loading"
    [alignImage]="'left'"
    [aspectRatio]="1"
    [attr.id]="field.id"
    [cropper]="cropper"
    [cropperMinWidth]="130"
    [imageURL]="thumbnailURL"
    [maintainAspectRatio]="true"
    [roundCropper]="false"
    [style.display]="cropperReady ? 'block' : 'none'"
    (cropperReady)="onCropperReady($event)"
    (imageCropped)="onImageCropped($event)"
    (imageLoaded)="onImageLoaded($event)"
  ></image-cropper>

  <ng-container *ngIf="!cropperReady" [ngTemplateOutlet]="loading"></ng-container>
</ng-container>

<ng-template #loadingThumbnail>
  <fa-icon icon="info-circle"></fa-icon>
  {{ "AstroBin is generating a large thumbnail." | translate }}
  {{ "This operation could take several seconds (especially for large images), please wait" | translate }}
  <astrobin-text-loading-indicator></astrobin-text-loading-indicator>
</ng-template>

<ng-template #loading>
  <astrobin-loading-indicator></astrobin-loading-indicator>
</ng-template>
